import { render } from "./AstrologyQRGenerator.vue?vue&type=template&id=4101fb08&scoped=true"
import script from "./AstrologyQRGenerator.vue?vue&type=script&lang=js"
export * from "./AstrologyQRGenerator.vue?vue&type=script&lang=js"

import "./AstrologyQRGenerator.vue?vue&type=style&index=0&id=4101fb08&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4101fb08"]])

export default __exports__